import { UserSettings } from 'components/UserSettings/components/UserSettings/UserSettings'
import { useCustomerSettings } from 'hooks/useCustomerSettings'
import React from 'react'
import isSSOLoggedIn from 'utils/isSSOLoggedIn'
import { useNavigate } from 'react-router'

const initialState = {}
export function userSettingsReducer(state: any = initialState) {
  return state
}

const UserSettingsContainer: React.FC = () => {
  const customerSettings = useCustomerSettings()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (isSSOLoggedIn()) {
      navigate('/')
    }
  }, [navigate])

  return (
    <div className="w-full flex-center p-2 sm:p-4">
      <div className="flex flex-wrap flex-col max-w-xl bg-white rounded-lg shadow-xs p-6">
        {customerSettings.emailLogin && <UserSettings />}
      </div>
    </div>
  )
}

export default UserSettingsContainer
